import { apiBase, apiDelete, apiGet, apiUpload } from "./client";

export type AttachmentDocType =
  | "sales_order"
  | "sales_invoice"
  | "purchase_invoice"
  | "purchase_order"
  | "goods_receipt"
  | "sales_delivery"
  | "sales_return"
  | "supplier_payment"
  | "customer_payment"
  | "stock_conversion"
  | "journal_entry"
  | "pos_ticket";

export type AttachmentRow = {
  id: string;
  fileName: string;
  contentType: string;
  byteSize: number;
  uploadedByUserId: string;
  uploaderLabel: string;
  createdAt: string;
};

export function listAttachments(
  companyRef: string,
  docType: AttachmentDocType,
  docId: string,
) {
  const q = new URLSearchParams({ docType, docId });
  return apiGet<{ attachments: AttachmentRow[] }>(
    `/c/${companyRef}/attachments?${q.toString()}`,
  );
}

export function uploadAttachment(
  companyRef: string,
  body: {
    docType: AttachmentDocType;
    docId: string;
    file: File;
  },
) {
  const form = new FormData();
  form.set("docType", body.docType);
  form.set("docId", body.docId);
  form.set("file", body.file);
  return apiUpload<{
    attachment: {
      id: string;
      fileName: string;
      contentType: string;
      byteSize: number;
    };
  }>(`/c/${companyRef}/attachments`, form);
}

export function deleteAttachment(companyRef: string, attachmentId: string) {
  return apiDelete<{ ok: true }>(
    `/c/${companyRef}/attachments/${attachmentId}`,
  );
}

export function attachmentContentUrl(
  companyRef: string,
  attachmentId: string,
): string {
  return `${apiBase()}/c/${companyRef}/attachments/${attachmentId}/content`;
}
